/* Rquiere de mixin.js */

var assistant = {
	data() {
		return {
			messagesAssistant: [],
			messagesOpenAI: [],
			listOpenAIs: [],
			petitionAssistant: '',
			askingAssistant: false,
			typingResponse: false,
			objectAssistant: {
				exist: 0,
				id: 0,
				url: null,
				api_key: null,
				name: null,
				model: null,
				initial_message: '',
				created_at: null,
				updated_at: null
			},
			searchingAssistant: false,
			savingAssistant: false,
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		_initDefaultAssistant() {
			this.messagesAssistant = []
			this.petitionAssistant = ''
			this.askingAssistant = false
		},
		askAssistant(id) {
			if (this.petitionAssistant.trim().length > 1) {
				let petition = this.petitionAssistant.trim()
				if (!this.isCommandFrontend(petition)) {
					this.askingAssistant = true
					this.messagesAssistant.push({ role: 'user', content: this.petitionAssistant.trim() })
					this.axiosActionIS(this.getApiBackend + 'assistant/' + id + '/sendMessage?message=' + petition, 'POST', 'askAssistantResult')
				}
				this.petitionAssistant = ''
			}
		},
		askAssistantResult(response) {

			this.askingAssistant = false
			if (response.data.success == true) {
				console.log(response.data)
				if (response.data.data.result == 1) {
					response.data.data.messages.forEach(m => {
						this.messagesAssistant.push(m.message)
					});
				} else if (response.data.data.result == 0) {
					this.messagesAssistant.push({ role: 'assistant', content: response.data.message, error: true })
				}
			}
			this.askAssistantResultLocal(response)
		},
		askAssistantResultLocal(response) {
			console.log('askAssistantResultLocal no está desarrollado', response)
		},
		getAllAssistants() {
			this.searchingAssistant = true
			this.listOpenAIs = []
			let url = this.apiBackend + 'assistants'
			this.axiosActionIS(url, 'GET', 'getAllAssistantsResult')
		},
		getAllAssistantsResult(response) {
			this.searchingAssistant = false
			if (response.data.success == true) {
				this.listOpenAIs = response.data.data
			}
			this.getAllAssistantsResultLocal(response)
		},
		getAllAssistantsResultLocal(response) {
			console.log('getAllAssistantsResultLocal no desarrollado', response)
		},
		insertPetition(petition, execute = false) {
			this.petitionAssistant = petition
			if (execute) {
				this.askAssistant()
			}
			this.insertPetitionResultLocal()
		},
		insertPetitionResultLocal() {
			console.log('insertPetitionResultLocal no desarrollado')
		},
		isCommandFrontend(petition) {
			let result = false
			switch (petition.toLowerCase()) {
				case 'clear':
				case 'limpiar':
					result = true
					this._initDefaultAssistant()
					break;
				case 'clear()':
					result = true
					console.clear()
					break;
				case 'isystem4':
					this.$router.push('/')
					result = true
				case 'isystem4 new':
					window.open('/', '_blank');
					result = true
					break;
				case 'aceschile':
					window.open('https://www.aceschile.cl/', '_blank');
					result = true
					break;
				case 'ver mensajes':
				case 'view messages':
					console.log(this.messagesOpenAI)
					break;
				default:
					break;
			}
			return result
		},
		saveAssistant() {
			this.savingAssistant = true
			let url = this.apiBackend + 'assistant/' + this.objectAssistant.id
			this.axiosActionIS(url, 'PUT', 'saveAssistantResult', this.objectAssistant)
		},
		saveAssistantResult(response) {
			this.savingAssistant = false
			if (response.data.success == true) {
				this.setObjectAssistant(response.data.data)
			}
			this.saveAssistantResultLocal(response)
		},
		saveAssistantResultLocal(response) {
			console.log('saveAssistantResultLocal no desarrollado', response)
		},
		setObjectAssistant(item) {
			for (const property in item) {
				this.objectAssistant[property] = item[property]
			}
		},
		showAssistant(id) {
			this.searchingAssistant = true
			let url = this.apiBackend + 'assistant/' + id
			this.axiosActionIS(url, 'GET', 'showAssistantResult')
		},
		showAssistantResult(response) {
			this.searchingAssistant = false
			if (response.data.success == true) {
				this.setObjectAssistant(response.data.data)
			}
			this.showAssistantResultLocal(response)
		},
		showAssistantResultLocal(response) {
			console.log('showAssistantResultLocal no desarrollado', response)
		}
	},
};

export default assistant;